import _ from 'lodash'
import { computed, onActivated, onDeactivated, onMounted, onUnmounted, ref, watch } from 'vue'

export default function (props: any, chart: any, resize: any) {
  const autoResizeTimer = ref()
  const preSize = ref({ width: 0, height: 0 })
  const currentSize = ref({ width: 0, height: 0 })
  const isShow = computed(() => {
    return currentSize.value.width > 0 && !_.isEqual(currentSize.value, preSize.value)
  })

  function updateCurrentSize () {
    currentSize.value = { width: _.get(chart.value, 'clientWidth', 0), height: _.get(chart.value, 'clientHeight', 0) }
  }

  function startAutoResizeTimer () {
    if (!props.autoResize) {
      clearAutoResizeTimer()
      return
    }
    if (autoResizeTimer.value > 0) {
      return
    }
    updateCurrentSize()
    autoResizeTimer.value = setInterval(() => {
      preSize.value = currentSize.value
      updateCurrentSize()
    }, 100)
  }

  function clearAutoResizeTimer () {
    if (autoResizeTimer.value > 0) {
      clearInterval(autoResizeTimer.value)
      autoResizeTimer.value = 0
    }
  }

  watch(() => props.autoResize, () => {
    startAutoResizeTimer()
  }, { immediate: true })

  watch(isShow, (v) => {
    if (v) {
      resize()
    }
  }, { immediate: true })

  onActivated(() => {
    startAutoResizeTimer()
  })

  onDeactivated(() => {
    clearAutoResizeTimer()
  })

  onMounted(() => {
    startAutoResizeTimer()
  })

  onUnmounted(() => {
    clearAutoResizeTimer()
  })

  return {
    isShow
  }
}
